/* global axios */
import ApiClient from './ApiClient';

class PartnersAPI extends ApiClient {
  constructor() {
    super('billing/partners', { accountScoped: true, apiVersion: 'v2' });
  }

  // O ApiClient já entrega get/create/update com a URL escopada na conta.
  // O slug não é enviado: o servidor gera um token opaco aleatório (PartnerSlugGenerator).
}

export default new PartnersAPI();
